import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const basePath = '/dealer/users/invite/accept';

@Injectable({
  providedIn: 'root'
})

export class DealerAcceptInviteService {
  constructor(private http: HttpClient) { }

  inviteAccept(userId: number) {
    return this.http.get(`${basePath}/${userId}`);
  }

}
